// extracted by mini-css-extract-plugin
export default {"emptyRosterDay":"RosterError_emptyRosterDay__F8epB","tooltip":"RosterError_tooltip__Ie-wn"};